import { SECTION_CUSTOM_EVENT, SECTION_CUSTOM_PARTICIPANT } from '@videotools/js/api/entities/TagGroup';
import { TAG_TYPE_CUSTOM } from '@videotools/js/api/entities/TagButton';

export const TAG_GROUP_PERMISSION_FULL = 'full';
export const TAG_GROUP_PERMISSION_READ = 'read';
export const TAG_GROUP_PERMISSION_GUEST = 'guest';

export default class PermissionManager {
	isGuest({ tagGroup }) {
		return tagGroup.permission === TAG_GROUP_PERMISSION_GUEST;
	}

	canViewTagCenter({ tagGroup }) {
		return [TAG_GROUP_PERMISSION_FULL, TAG_GROUP_PERMISSION_GUEST].includes(tagGroup?.permission);
	}

	canViewTagGroupSection({ tagGroup, section }) {
		if (TAG_GROUP_PERMISSION_FULL === tagGroup.permission) {
			return true;
		}
		return !!(tagGroup.isSystemDefault && [SECTION_CUSTOM_PARTICIPANT, SECTION_CUSTOM_EVENT].includes(section));
	}

	canEditEventTag({ tagGroup, eventTag }) {
		const permission = tagGroup?.permission;
		if (!permission) {
			return false;
		}
		if (permission === TAG_GROUP_PERMISSION_FULL) {
			return true;
		}
		return permission === TAG_GROUP_PERMISSION_GUEST && eventTag.tag.type === TAG_TYPE_CUSTOM;
	}

	canDeleteEventTag() {
		return this.canEditEventTag(arguments);
	}

	canCreateTagGroups({ defaultTagGroup }) {
		const permission = defaultTagGroup.permission;
		return [TAG_GROUP_PERMISSION_FULL, TAG_GROUP_PERMISSION_GUEST].includes(permission);
	}

	canUseMultiFormatTool(eventPermissions) {
		return eventPermissions.find(permission => permission?.key === 'useMultiFormatTool')?.value;
	}

	canUpdateTagTemplates(eventPermissions) {
		return eventPermissions.find(permission => permission?.key === 'updateTagTemplates')?.value;
	}

	canCreateHighlightRule(eventPermissions) {
		return eventPermissions.find(permission => permission?.key === 'createHighlightRule')?.value;
	}

	canManageGraphics(eventPermissions) {
		return eventPermissions.find(permission => permission?.key === 'manageGraphics')?.value;
	}

	canUseHighlightIq(eventPermissions) {
		return eventPermissions.find(permission => permission?.key === 'useHighlightIq')?.value;
	}
}
